/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** inquiry-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** inquiry-controller inquiryDetails */
export async function inquiryDetailsGet(
  payload: {
    inquiryId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultInquiryDetailResp>({
    url: `/es/api/biz/inquiry/inquiry/details`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller inquiryDetailsCompanyList */
export async function inquiryDetailsCompanyListGet(
  payload: {
    filter: number;
    inquiryId: string;
    page: number;
    pageSize: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultInquiryDetailResp>({
    url: `/es/api/biz/inquiry/inquiry/details/company/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller inquiryList */
export async function inquiryListGet(
  payload: {
    filter?: string;
    page: number;
    pageSize: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultInquiryListResp>({
    url: `/es/api/biz/inquiry/inquiry/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller operateInquiry */
export async function operateInquiryPost(payload: model.IApiInquiryTaskOperateReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryOperateResp>({
    url: `/es/api/biz/inquiry/inquiry/operate`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** inquiry-controller replaceInquiry */
export async function replaceInquiryPost(payload: model.IApiInquiryStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryOperateResp>({
    url: `/es/api/biz/inquiry/inquiry/replace`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** inquiry-controller inquiryRequest */
export async function inquiryRequestGet(
  payload: {
    inquiryId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultInquiryRequestResp>({
    url: `/es/api/biz/inquiry/inquiry/request`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller saveInquiry */
export async function saveInquiryPost(payload: model.IApiInquiryStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryStartResp>({
    url: `/es/api/biz/inquiry/inquiry/save`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** inquiry-controller startInquiry */
export async function startInquiryPost(payload: model.IApiInquiryStartReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryStartResp>({
    url: `/es/api/biz/inquiry/inquiry/start`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** inquiry-controller inquiryStats */
export async function inquiryStatsGet(
  payload: {
    inquiryId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultInquiryStats>({
    url: `/es/api/biz/inquiry/inquiry/stats`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller getInquiryLogs */
export async function getInquiryLogsGet(
  payload: {
    inquiryId: string;
    sort?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultListInquiryLogSubStepResp>({
    url: `/es/api/biz/inquiry/logs`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller getMessageId */
export async function getMessageIdGet(
  payload: {
    inquiryTaskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultGetMessageInfoResp>({
    url: `/es/api/biz/inquiry/task/messageId`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller taskReplyList */
export async function taskReplyListGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultTaskReplyListResp>({
    url: `/es/api/biz/inquiry/task/replyList`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** inquiry-controller startCompanyTask */
export async function startCompanyTaskPost(payload: model.IApiCompanyTaskReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultInquiryStartResp>({
    url: `/es/api/biz/inquiry/task/start`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** inquiry-controller stopCompanyTask */
export async function stopCompanyTaskPost(payload: model.IApiCompanyTaskReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/inquiry/task/stop`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
